import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  const [showPopup, setShowPopup] = useState(false);
  const [popupMsg, setPopupMsg] = useState("");

  const showComingSoon = () => {
    setPopupMsg("Still developing, Coming Soon 🚧");
    setShowPopup(true);

    setTimeout(() => {
      setShowPopup(false);
    }, 2000);
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="navbar">
          <Link to="/" className="logo">
            <img
              src="/images/ProfileAvatar.gif"
              alt="Logo"
              className="logo-gif"
            />
          </Link>

          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/journey">Journey</Link></li>
            <li><Link to="/projects">My Works</Link></li>

            {/* Certifications */}
            <li><Link to="/certifications">Certifications</Link></li>

            {/* Certifications Disabled */}
            <li>
              <span
                className="disabled-link"
                onClick={showComingSoon}
                onMouseEnter={showComingSoon}
              >
                Publications
              </span>
            </li>

            {/* Blogs Disabled */}
            <li>
              <span
                className="disabled-link"
                onClick={showComingSoon}
                onMouseEnter={showComingSoon}
              >
                Blogs ↗
              </span>
            </li>
          </ul>

          <div className="nav-actions">
            <a href="#contact" className="btn btn-contact">Contact Me </a>
          </div>
        </nav>
      </div>

      {/* Popup Message */}
      {showPopup && (
        <div className="coming-soon-popup">
          {popupMsg}
        </div>
      )}
    </header>
  );
}

export default Header;
